import { createFileRoute, Outlet } from '@tanstack/react-router'

/** One employee and their edit page (which sits under the employee's crumb). */
export const Route = createFileRoute('/_app/hr/employees/$employeeId')({
  staticData: { crumb: 'hrEmployee' },
  component: Outlet,
})
